module.exports = __webpack_public_path__ + "static/antivol2-0caacb7286118436074206d6640e0023.jpg";